"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasteIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const PasteIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({ viewBox: "0 0 30 30" }, props),
    react_1.default.createElement("path", { d: "M21.5,6.5h-11V5A1.5,1.5,0,0,1,12,3.5h2a.5.5,0,0,0,.5-.5,1.5,1.5,0,0,1,3,0,.5.5,0,0,0,.5.5h2A1.5,1.5,0,0,1,21.5,5Z" }),
    react_1.default.createElement("path", { d: "M25.5,7V27A1.5,1.5,0,0,1,24,28.5H8A1.5,1.5,0,0,1,6.5,27V7A1.5,1.5,0,0,1,8,5.5H9.5V7a.5.5,0,0,0,.5.5H22a.5.5,0,0,0,.5-.5V5.5H24A1.5,1.5,0,0,1,25.5,7Z" })));
exports.PasteIcon = PasteIcon;
exports.default = exports.PasteIcon;
